<template>
  <Window
    title="News"
    window-name="news"
    :icon-src="require('@/assets/task-bar-icons/icon-news.svg')"
  >
    <div class="back-button-container">
      <button @click="onBackButtonClick" v-if="showBackButton">
        <span class="material-icons">
          arrow_back
        </span>
      </button>
    </div>
    <iframe
      ref="iframe"
      class="iframe"
      frameborder="0"
      width="100%"
      height="100%"
      src="/webflowUPDATE/news-site/old-home-copy.html"
      @load="onIframeLoad"
    ></iframe
  ></Window>
</template>

<script>
import Window from "@/components/shared/Window";

export default {
  name: "NewsWindow",
  components: { Window },
  data() {
    return { showBackButton: false };
  },
  methods: {
    onIframeLoad() {
      this.showBackButton =
        this.$refs.iframe.contentWindow.location.pathname !==
        "/webflowUPDATE/news-site/old-home-copy.html";
    },
    onBackButtonClick() {
      if (
        this.$refs.iframe.contentWindow.location.pathname !==
        "/webflowUPDATE/news-site/old-home-copy.html"
      )
        this.$refs.iframe.contentWindow.history.back();
    },
  },
};
</script>

<style scoped lang="scss">
.back-button-container {
  height: 54px;

  button {
    height: 100%;
    background: none;
    border: none;
    padding: 16px;
    user-select: none;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    transition-property: background-color;
    transition-duration: 100ms;
    transition-timing-function: ease-in-out;

    background-color: mix(purple, white, 40%);

    &:hover {
      background-color: mix(purple, white, 50%);
    }

    &:active {
      background-color: mix(purple, white, 80%);
    }
  }
}

.iframe {
}
</style>
